<h1 mat-dialog-title>
    <span>
        <span [translate]="'admin.frais.indemnites.reglesAttribution.detail.prestations.popup.title'"></span>
        <mat-icon class="material-icons-outlined ms-2"
                  [matTooltip]="'admin.frais.indemnites.reglesAttribution.detail.prestations.popup.information' | translate"
                  matTooltipPosition="right">info</mat-icon>
    </span>
    <span type="button" (click)="onCancel()"><i class="zmdi zmdi-close"></i></span>
</h1>

<div mat-dialog-content>
    <form autocomplete="off" #prestationAddForm="ngForm">
        <fieldset>
            <div class="row">
                <label class="col-md-2 required">
                    <span [translate]="'admin.frais.indemnites.reglesAttribution.detail.prestations.colonnes.prestation'"></span>
                </label>
                <div class="col-md-10">
                    <div class="r-flex align-items-center">
                        <autocomplete
                                ngDefaultControl
                                class="flex-grow-1"
                                #prestation="ngModel"
                                name="prestation"
                                [options]="prestationOptions"
                                [filter]="filtrePrestation"
                                [(ngModel)]="reglePresta.prestation"
                                [required]="true"
                                [floatLabel]="'never'"
                                (onSelect)="onPrestationChange()">
                        </autocomplete>
                        <mat-icon class="material-icons-outlined ms-2"
                                  [matTooltip]="'admin.frais.indemnites.reglesAttribution.detail.prestations.popup.tooltip' | translate"
                                  matTooltipPosition="right">info</mat-icon>
                    </div>
                </div>
            </div>

            <div class="row">
                <custom-input
                        ngDefaultControl
                        name="domaine"
                        customType="input"
                        [ngModel]="domainePrestation"
                        [readonly]="true"
                        lCol="2"
                        rCol="10"
                        libelle="admin.frais.indemnites.reglesAttribution.detail.prestations.colonnes.domaine">
                </custom-input>
            </div>

            <div class="row">
                <custom-input
                        ngDefaultControl
                        name="quantite"
                        customType="number"
                        [(ngModel)]="reglePresta.qte"
                        [disabled]="true"
                        [min]="1"
                        [nbDecimales]="0"
                        [postTooltip]="'admin.frais.indemnites.reglesAttribution.detail.prestations.popup.quantiteFixe' | translate"
                        libelle="admin.frais.indemnites.reglesAttribution.detail.prestations.colonnes.quantite">
                </custom-input>
            </div>
        </fieldset>
    </form>
</div>

<div mat-dialog-actions>
    <button mat-stroked-button (click)="onCancel()">
        <span [translate]="'global.actions.annuler'"></span>
    </button>
    <button mat-flat-button color="primary" (click)="onValidate()" [disabled]="!reglePresta?.prestation">
        <span [translate]="'global.actions.ajouter'"></span>
    </button>
</div>
